module.exports = __webpack_public_path__ + "static/media/dirgha_mi.9d83da81.ogg";